import { isEmpty, isString } from "../../utils/is.js";
import _objectSpread2 from "../../_virtual/_@oxc-project_runtime@0.143.0/helpers/esm/objectSpread2.js";
//#region src/api/meta/initialize.ts
function initializeMetaAPI({ internalLogger, metas }) {
	internalLogger.debug("Initializing meta API");
	let metaSession = void 0;
	let metaUser = void 0;
	let metaView = void 0;
	let metaPage = void 0;
	const setUser = (user) => {
		if (metaUser) metas.remove(metaUser);
		metaUser = { user };
		metas.add(metaUser);
	};
	const setSession = (session, options) => {
		var _metaSession$session;
		const newOverrides = options === null || options === void 0 ? void 0 : options.overrides;
		const overrides = newOverrides ? { overrides: _objectSpread2(_objectSpread2({}, metaSession === null || metaSession === void 0 || (_metaSession$session = metaSession.session) === null || _metaSession$session === void 0 ? void 0 : _metaSession$session.overrides), newOverrides) } : {};
		if (metaSession) metas.remove(metaSession);
		metaSession = { session: _objectSpread2(_objectSpread2({}, isEmpty(session) ? void 0 : session), overrides) };
		metas.add(metaSession);
	};
	const getSession = () => metas.value.session;
	const setView = (view, options) => {
		var _metaView$view;
		if (options === null || options === void 0 ? void 0 : options.overrides) setSession(getSession(), { overrides: options.overrides });
		if ((metaView === null || metaView === void 0 || (_metaView$view = metaView.view) === null || _metaView$view === void 0 ? void 0 : _metaView$view.name) === (view === null || view === void 0 ? void 0 : view.name)) return;
		const previousView = metaView;
		metaView = { view };
		metas.add(metaView);
		if (previousView) metas.remove(previousView);
	};
	const getView = () => metas.value.view;
	const setPage = (page) => {
		var _metaPage$page;
		const pageMeta = isString(page) ? _objectSpread2(_objectSpread2({}, (_metaPage$page = metaPage === null || metaPage === void 0 ? void 0 : metaPage.page) !== null && _metaPage$page !== void 0 ? _metaPage$page : getPage()), {}, { id: page }) : page;
		if (metaPage) metas.remove(metaPage);
		metaPage = { page: pageMeta };
		metas.add(metaPage);
	};
	const getPage = () => metas.value.page;
	return {
		setUser,
		resetUser: setUser,
		setSession,
		resetSession: setSession,
		getSession,
		setView,
		getView,
		setPage,
		getPage
	};
}
//#endregion
export { initializeMetaAPI };

//# sourceMappingURL=initialize.js.map